import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiSiteProfilesData = () => {
    const { allStrapiMedia } = useStaticQuery(graphql`
        query {
            allStrapiMedia(filter: {ext: {eq: ".pdf"}}) {
                nodes {
                  name
                  localFile {
                    prettySize
                    }
                }
            }
        }
    `)

    return { allStrapiMedia }
}